import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/PreExamLS-default'

// 枚举

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

export class UpDownSettingsDto {
  upping: boolean
  upPlainTime?: string
  downPlainTime?: string
}

/**
 * 申请选课Token信息
 */
export class ApplyChooseCourseTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
}

/**
 * 每日一练学习Token信息
 */
export class ApplyDailyExaminationTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
}

/**
 * 考试Token信息
 */
export class ApplyExamLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
}

/**
 * 考纲结构易错题学习Token
 */
export class ApplyExamOutlineErrorPronePracticeLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
  /**
   * 考纲树id
   */
  syllabusId?: string
  /**
   * 考纲元素id
   */
  syllabusMataId?: string
}

/**
 * 申请考纲模式的练习学习Token
 */
export class ApplyExamOutlinePracticeLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
  /**
   * 章节ID
   */
  chaptersId?: string
  /**
   * 题类 null全部，real真题，practice练习题，simulation模拟题
   */
  questionCategory?: string
  /**
   * 考纲元素id
   */
  syllabusMataId?: string
}

/**
 * 题型方式易错题学习Token
 */
export class ApplyQuestionTypeErrorPronePracticeLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 题型,-1全部,1判断题,2单选题,3多选题,6案例题
   */
  questionType: number
  /**
   * 考纲树id
   */
  syllabusId?: string
}

export class ApplyRandomPracticeLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
  /**
   * 抽题模式,1:未答优先其次作答次数较少优先,2:未答,3:已答且次数较少优先
   */
  extractMode: number
  /**
   * 抽题总数
   */
  questionCount: number
  /**
   * 题型,-1全部,1判断题,2单选题,3多选题,6案例题
   */
  questionType: number
}

/**
 * 申请课程学习Token信息
 */
export class ApplySingleCourseLearningTokenRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数ID
   */
  issueId?: string
  /**
   * 课程包ID
   */
  packageId?: string
  /**
   * 课程ID
   */
  courseId?: string
}

/**
 * 商品上下架状态
@author eleven
 */
export class CommoditySkuUppingRequest {
  /**
   * 学习方案id
   */
  schemeId?: string
  /**
   * 期数id
   */
  issueId?: string
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
}

/**
 * 课程学习方式设置信息
 */
export class CourseLearningSettingsRequest {
  /**
   * 是否启用课程学习方式
   */
  enabled: boolean
  /**
   * 课程包ID集合
   */
  packageIds?: Array<string>
  /**
   * 是否仅系统推送
   */
  systemPush: boolean
}

/**
 * 缩减有效期信息
 */
export class CurtailValidPeriodRequest {
  /**
   * 学员身份ID
   */
  studentIdentityId: string
  /**
   * 缩减天数
   */
  curtailDay: number
}

/**
 * 每日一卷
@author eleven
@date 2020/12/8
 */
export class DailyExaminationSettingsRequest {
  /**
   * 是否启用每日一卷
   */
  enabled: boolean
  /**
   * 每日一卷名称
   */
  name?: string
  /**
   * 考试卷id
   */
  examPaperId?: string
  /**
   * 发布类型
0:不发布 1:马上发布 2:限时
   */
  publishType: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 每日一卷id
   */
  id?: string
}

/**
 * 每日一练配置信息
 */
export class DailyPracticeSettingsRequest {
  /**
   * 是否启用每日一练
   */
  enabled: boolean
}

/**
 * 商品上下架状态
@author eleven
 */
export class EffectiveCommoditySkuUppingRequest {
  /**
   * 学习方案id
   */
  schemeId?: string
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
}

/**
 * @author eleven
 */
export class EffectiveLSCreateRequest {
  /**
   * 有效期天数
   */
  validDay: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsDto
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 考试类别ID
   */
  examTypeId?: string
  /**
   * 考试类别名称
   */
  examTypeName?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 专业名称
   */
  professionName?: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 所属考纲
   */
  syllabusId?: string
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * @author eleven
 */
export class EffectiveLSUpdateRequest {
  /**
   * 有效期天数
   */
  validDay: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsDto
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * 易错题练习配置
 */
export class ErrorPronePracticeSettingsRequest {
  /**
   * 是否启用易错题练习
   */
  enabled: boolean
}

/**
 * 考试学习方式设置信息
 */
export class ExamLearningSettingsRequest {
  /**
   * 是否启用考试学习方式
   */
  enabled: boolean
  /**
   * 考试名称
   */
  name?: string
  /**
   * 试卷ID
   */
  examPaperId?: string
  /**
   * 考试时长，单位分钟
   */
  examTimeLength: number
  /**
   * 考试次数 0表示不限制次数
   */
  examCount: number
  /**
   * 及格分数
   */
  passScore: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 最短提交时长
   */
  minSubmitTimeLength: number
  /**
   * 多选漏选是否的分
   */
  less: boolean
  /**
   * 漏选得分模式
0:不得分，适用于漏选不得分情况
1:全得
2:得一半
3:平均得分
   */
  missScorePattern: number
  /**
   * 是否配置考试时间
   */
  configExamTime: boolean
  /**
   * 开考时间
   */
  beginTime?: string
  /**
   * 结束时间
   */
  endTime?: string
}

/**
 * 延长有效期信息
 */
export class ExtendValidPeriodRequest {
  /**
   * 学员身份ID
   */
  studentIdentityId: string
  /**
   * 延长天数
   */
  renewalDay: number
}

export class PreExamLSCreateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 考试类别ID
   */
  examTypeId?: string
  /**
   * 考试类别名称
   */
  examTypeName?: string
  /**
   * 专业ID
   */
  professionId?: string
  /**
   * 专业名称
   */
  professionName?: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure?: string
  /**
   * 所属考纲
   */
  syllabusId?: string
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * 考前学习方案期数创建信息
 */
export class PreExamLSIssueCreateRequest {
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 期数名称
   */
  title?: string
  /**
   * 培训开始时间
   */
  startTime?: string
  /**
   * 培训结束时间
   */
  endTime?: string
  /**
   * 线下考试时间
   */
  offlineExamTime?: string
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 排序
   */
  sort: number
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsRequest
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

/**
 * 考前学习方案期数更新信息
 */
export class PreExamLSIssueUpdateRequest {
  /**
   * 要更新期数的学习方案ID
   */
  schemeId?: string
  /**
   * 要更新的期数ID
   */
  issueId?: string
  /**
   * 期数名称
   */
  title?: string
  /**
   * 培训开始时间
   */
  startTime?: string
  /**
   * 培训结束时间
   */
  endTime?: string
  /**
   * 线下考试时间
   */
  offlineExamTime?: string
  /**
   * 排序
   */
  sort: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price?: number
  /**
   * 上下架设置
   */
  upDownSettings?: UpDownSettingsDto
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

export class PreExamLSUpdateRequest {
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 培训方案名称
   */
  name?: string
  /**
   * 封面图片地址
   */
  picture?: string
  /**
   * 课程学习方式设置信息
   */
  courseLearningSettings?: CourseLearningSettingsRequest
  /**
   * 考试学习方式设置信息
   */
  examLearningSettings?: ExamLearningSettingsRequest
  /**
   * 试题练习学习方式配置
   */
  questionPracticeLearningSettings?: QuestionPracticeLearningSettingsRequest
  /**
   * 每日一练配置
   */
  dailyPracticeSettings?: DailyPracticeSettingsRequest
  /**
   * 易错题配置
   */
  errorPronePracticeSettings?: ErrorPronePracticeSettingsRequest
  /**
   * 每日一卷配置
   */
  dailyExaminationSettings?: DailyExaminationSettingsRequest
}

/**
 * 试题练习学习方式配置
 */
export class QuestionPracticeLearningSettingsRequest {
  /**
   * 是否启用试题练习
   */
  enabled: boolean
  /**
   * 抽题方式，1：指定考纲方式，2：按试题题型及抽题比例
   */
  fetchWay: number
  /**
   * 是否开放真题
   */
  openReal: boolean
  /**
   * 是否开放练习题
   */
  openPractice: boolean
  /**
   * 是否开放模拟题
   */
  openSimulation: boolean
  /**
   * 真题比率
   */
  realRatioValue: number
  /**
   * 练习题比率
   */
  practiceRatioValue: number
  /**
   * 模拟题比率
   */
  simulationRatioValue: number
}

/**
 * 学员身份分组创建信息
 */
export class StudentIdentityGroupCreateRequest {
  /**
   * 学习方案ID
   */
  schemeId?: string
  /**
   * 分组名称
   */
  groupName: string
}

/**
 * 学员身份分组查询信息
 */
export class StudentIdentityGroupQueryRequest {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 分组名称
   */
  groupName?: string
  /**
   * 单位id集合
   */
  schemeIdList?: Array<string>
}

/**
 * 学员身份分组更新信息
 */
export class StudentIdentityGroupUpdateRequest {
  /**
   * 分组ID
   */
  id: string
  /**
   * 分组名称
   */
  groupName: string
}

/**
 * 学员身份查询信息
 */
export class StudentIdentityPageQueryRequest {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 用户ID集合
   */
  userIds?: Array<string>
  /**
   * 报名时间起始查询
   */
  startCreateTime?: string
  /**
   * 报名时间截止查询
   */
  endCreateTime?: string
  /**
   * 分组ID集合
   */
  groupIds?: Array<string>
  /**
   * 是否延长有效期查询，null不查询
   */
  isRenewal?: boolean
}

/**
 * 学员身份排序
 */
export class StudentIdentityPageSortRequest {
  /**
   * null 不排序，true 升序，false降序
   */
  usageEndDate?: boolean
}

/**
 * 更新学员身份信息
 */
export class StudentIdentityUpdateRequest {
  /**
   * 身份ID
   */
  id: string
  /**
   * 分组ID
   */
  groupId?: string
}

/**
 * 商品SKU上下架设置
 */
export class UpDownSettingsRequest {
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
  /**
   * 计划上架时间
如果 upping 为 true 该值无效
   */
  upPlainTime?: string
  /**
   * 计划下架时间
如果 upping 为 false 该值无效
   */
  downPlainTime?: string
}

/**
 * 课程学习方式信息
 */
export class CourseLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用课程学习方式
   */
  enabled: boolean
  /**
   * 课程包ID集合
   */
  packageIds: Array<string>
  /**
   * 是否仅系统推送
   */
  systemPush: boolean
}

/**
 * 每日一卷
@author eleven
@date 2020/12/8
 */
export class DailyExaminationResponse {
  /**
   * 是否启用每日一练
   */
  enabled: boolean
  /**
   * 每日一卷id
   */
  id: string
  /**
   * 每日一卷名称
   */
  name: string
  /**
   * 考试卷id
   */
  examPaperId: string
  /**
   * 发布类型
0:不发布 1:马上发布 2:限时
   */
  publishType: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
}

/**
 * 每日一练信息
 */
export class DailyPracticeResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用每日一练
   */
  enabled: boolean
}

/**
 * 期数和商品SKU信息
 */
export class EffectiveLSAndCommoditySkuResponse {
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 商品SkuId
   */
  newEffectiveCommoditySkuId: string
  /**
   * 有效期天数
   */
  validDay: number
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price: number
  /**
   * 上下架设置
   */
  upDownSettings: UpDownSettingsResponse
  /**
   * 补考商品sku
   */
  resitEffectiveCommoditySkuId: string
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm: string
  /**
   * 课程学习方式信息
   */
  courseLearning: CourseLearningResponse
  /**
   * 考试学习方式信息
   */
  examLearning: ExamLearningResponse
  /**
   * 试题练习学习方式信息
   */
  questionPracticeLearning: QuestionPracticeLearningResponse
  /**
   * 每日一练信息
   */
  dailyPractice: DailyPracticeResponse
  /**
   * 易错题练习信息
   */
  errorPronePractice: ErrorPronePracticeResponse
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
  /**
   * 所属考纲
   */
  syllabusId: string
  /**
   * 每日一卷
   */
  dailyExamination: DailyExaminationResponse
}

/**
 * 易错题练习信息
 */
export class ErrorPronePracticeResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用易错题练习
   */
  enabled: boolean
}

/**
 * 考试学习方式信息
 */
export class ExamLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用考试学习方式
   */
  enabled: boolean
  /**
   * 考试名称
   */
  name: string
  /**
   * 试卷ID
   */
  examPaperId: string
  /**
   * 考试时长，单位分钟
   */
  examTimeLength: number
  /**
   * 考试次数 0表示不限制次数
   */
  examCount: number
  /**
   * 及格分数
   */
  passScore: number
  /**
   * 是否开放试题解析
   */
  openResolvedExam: boolean
  /**
   * 最短提交时长
   */
  minSubmitTimeLength: number
  /**
   * 开考时间
   */
  beginTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 多选漏选是否的分
   */
  less: boolean
  /**
   * 漏选得分模式
0:不得分，适用于漏选不得分情况
1:全得
2:得一半
3:平均得分
   */
  missScorePattern: number
  /**
   * 是否配置考试时间
   */
  configExamTime: boolean
}

/**
 * 期数和商品SKU信息
 */
export class IssueAndCommoditySkuResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 商品SkuId
   */
  commoditySkuId: string
  /**
   * 标题
   */
  title: string
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 是否开放报名
   */
  openEnrolment: boolean
  /**
   * 销售价格
   */
  price: number
  /**
   * 上下架设置
   */
  upDownSettings: UpDownSettingsResponse
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
}

/**
 * 考前学习方案信息
 */
export class PreExamLSResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see TrainingFormConst
   */
  trainingForm: string
  /**
   * 课程学习方式信息
   */
  courseLearning: CourseLearningResponse
  /**
   * 考试学习方式信息
   */
  examLearning: ExamLearningResponse
  /**
   * 试题练习学习方式信息
   */
  questionPracticeLearning: QuestionPracticeLearningResponse
  /**
   * 每日一练信息
   */
  dailyPractice: DailyPracticeResponse
  /**
   * 易错题练习信息
   */
  errorPronePractice: ErrorPronePracticeResponse
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
  /**
   * 所属考纲
   */
  syllabusId: string
  /**
   * 每日一卷
   */
  dailyExamination: DailyExaminationResponse
}

/**
 * 试题练习学习方式信息
 */
export class QuestionPracticeLearningResponse {
  /**
   * 学习方式ID
   */
  learningId: string
  /**
   * 是否启用试题练习
   */
  enabled: boolean
  /**
   * 抽题方式，1：指定考纲方式，2：按试题题型及抽题比例
   */
  fetchWay: number
  /**
   * 是否开放真题
   */
  openReal: boolean
  /**
   * 是否开放练习题
   */
  openPractice: boolean
  /**
   * 是否开放模拟题
   */
  openSimulation: boolean
  /**
   * 真题比率
   */
  realRatioValue: number
  /**
   * 练习题比率
   */
  practiceRatioValue: number
  /**
   * 模拟题比率
   */
  simulationRatioValue: number
}

/**
 * 学员身份分组下学员数量信息
 */
export class StudentIdentityGroupCountResponse {
  /**
   * 分组ID
   */
  groupId: string
  /**
   * 学员数量
   */
  count: number
}

/**
 * 学员身份分组
 */
export class StudentIdentityGroupResponse {
  /**
   * 分组ID
   */
  id: string
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 分组名称
   */
  groupName: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 创建人ID
   */
  createUserId: string
}

/**
 * 学员身份信息
 */
export class StudentIdentityPageItemResponse {
  /**
   * 身份ID
   */
  id: string
  /**
   * 用户ID
   */
  userId: string
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期别ID
   */
  stageId: string
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 身份状态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.StudentIdentityStatusConst
   */
  status: number
  /**
   * 身份类型
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.StudentIdentityTypeConst
   */
  identityType: number
  /**
   * 培训形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm: string
  /**
   * 生效日期
   */
  effectiveDate: string
  /**
   * 过期日期
   */
  expireDate: string
  /**
   * 是否过期
   */
  expired: boolean
  /**
   * 来源类型
   */
  sourceType: string
  /**
   * 来源ID
   */
  sourceId: string
  /**
   * 父级身份ID，目前资源补考身份拥有父级身份（新训身份）
   */
  parentId: string
  /**
   * 分组ID
   */
  groupId: string
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 分组名称
   */
  groupName: string
  /**
   * 初始有效天数
   */
  initDay: number
  /**
   * 延长天数
   */
  renewalDay: number
}

/**
 * 学员身份信息
 */
export class StudentIdentityResponse {
  /**
   * 身份ID
   */
  id: string
  /**
   * 用户ID
   */
  userId: string
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期别ID
   */
  stageId: string
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 身份状态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.StudentIdentityStatusConst
   */
  status: number
  /**
   * 身份类型
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.StudentIdentityTypeConst
   */
  identityType: number
  /**
   * 培训形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm: string
  /**
   * 生效日期
   */
  effectiveDate: string
  /**
   * 过期日期
   */
  expireDate: string
  /**
   * 是否过期
   */
  expired: boolean
  /**
   * 来源类型
   */
  sourceType: string
  /**
   * 来源ID
   */
  sourceId: string
  /**
   * 父级身份ID，目前资源补考身份拥有父级身份（新训身份）
   */
  parentId: string
  /**
   * 分组ID
   */
  groupId: string
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 剩余有效天数
   */
  remainEffectiveDay: number
}

/**
 * 商品SKU上下架设置
 */
export class UpDownSettingsResponse {
  /**
   * 是否上架
true: 如果商品SKU处于下架状态将进行立即上架
false: 如果商品SKU处于上架状态将进行立即下架
   */
  upping: boolean
  /**
   * 计划上架时间
如果 upping 为 true 该值无效
   */
  upPlainTime: string
  /**
   * 计划下架时间
如果 upping 为 false 该值无效
   */
  downPlainTime: string
}

/**
 * 用户期数信息
 */
export class UserPreExamLSIssueResponse {
  /**
   * 用户ID
   */
  userId: string
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期别ID
   */
  stageId: string
  /**
   * 期数ID
   */
  issueId: string
  /**
   * 期数标题
   */
  title: string
  /**
   * 状态
   */
  status: number
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 是否显示线下考试时间
   */
  showOfflineExamTime: boolean
  /**
   * 是否有效
   */
  effective: boolean
  /**
   * 考试倒计时天数
   */
  remainOfflineExamDay: number
}

/**
 * 考前学习方案信息
 */
export class UserPreExamLSResponse {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 是否仅系统推送
   */
  systemPush: boolean
  /**
   * 培训形态
EFFECTIVE: 有效期形态  ISSUE:期数形态
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.TrainingFormConst
   */
  trainingForm: string
  /**
   * 呈现结构
@see com.fjhb.platform.core.learningscheme.v1.preexam.api.constants.PresentationStructure
   */
  presentationStructure: string
  /**
   * 所属考纲
   */
  syllabusId: string
}

/**
 * 学员身份有效期操作记录信息
 */
export class ValidPeriodRecordResponse {
  /**
   * 记录ID
   */
  id: string
  /**
   * 学员身份ID
   */
  studentIdentityId: string
  /**
   * 记录类型，1：延长，2：缩减
   */
  type: number
  /**
   * 应用起始日期
   */
  usageBeginDate: string
  /**
   * 应用截止日期
   */
  usageEndDate: string
  /**
   * 应用天数
   */
  usageDay: number
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
}

export class StudentIdentityGroupResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<StudentIdentityGroupResponse>
}

export class StudentIdentityPageItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<StudentIdentityPageItemResponse>
}

export class ValidPeriodRecordResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<ValidPeriodRecordResponse>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取当前用户的所有学习方案
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllByUser(
    query: DocumentNode = GraphqlImporter.findAllByUser,
    operation?: string
  ): Promise<Response<Array<UserPreExamLSResponse>>> {
    return commonRequestApi<Array<UserPreExamLSResponse>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 查询指定学习方案的所有学员身份分组
   * @param schemeId 学习方案ID
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllGroup(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.findAllGroup,
    operation?: string
  ): Promise<Response<Array<StudentIdentityGroupResponse>>> {
    return commonRequestApi<Array<StudentIdentityGroupResponse>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 获取有效期形态的培训方案
   * @param schemeId 学习方案ID
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findEffectiveLSById(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.findEffectiveLSById,
    operation?: string
  ): Promise<Response<EffectiveLSAndCommoditySkuResponse>> {
    return commonRequestApi<EffectiveLSAndCommoditySkuResponse>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 批量查询学员身份分组学员数量
   * @param groupIds 分组ID集合
   * @param query 查询 graphql 语法文档
   * @param groupIds 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findGroupCounts(
    groupIds: Array<string>,
    query: DocumentNode = GraphqlImporter.findGroupCounts,
    operation?: string
  ): Promise<Response<Array<StudentIdentityGroupCountResponse>>> {
    return commonRequestApi<Array<StudentIdentityGroupCountResponse>>(SERVER_URL, {
      query: query,
      variables: { groupIds },
      operation: operation
    })
  }

  /**   * [分页]学员身份分组查询
   * @param page 分页信息
   * @param queries 查询信息
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findGroupPageList(
    params: { page?: Page; queries?: StudentIdentityGroupQueryRequest },
    query: DocumentNode = GraphqlImporter.findGroupPageList,
    operation?: string
  ): Promise<Response<StudentIdentityGroupResponsePage>> {
    return commonRequestApi<StudentIdentityGroupResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取期数形态的培训方案
   * @param schemeId 学习方案ID
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findIssueLSById(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.findIssueLSById,
    operation?: string
  ): Promise<Response<PreExamLSResponse>> {
    return commonRequestApi<PreExamLSResponse>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 查询当前用户指定学习方案报名的所有期数
   * @param schemeId 学习方案ID
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findIssueListByCurrentUser(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.findIssueListByCurrentUser,
    operation?: string
  ): Promise<Response<Array<UserPreExamLSIssueResponse>>> {
    return commonRequestApi<Array<UserPreExamLSIssueResponse>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 查询当前用户指定学习方案报名的所有学员身份
   * @param schemeId 学习方案ID
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findStudentIdentityListByCurrentUser(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.findStudentIdentityListByCurrentUser,
    operation?: string
  ): Promise<Response<Array<StudentIdentityResponse>>> {
    return commonRequestApi<Array<StudentIdentityResponse>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * [分页]查询学员身份列表（即报名记录）
   * @param page 分页信息
   * @param queries 查询信息
   * @param sort 排序信息
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findStudentIdentityPageList(
    params: { page?: Page; queries?: StudentIdentityPageQueryRequest; sort?: StudentIdentityPageSortRequest },
    query: DocumentNode = GraphqlImporter.findStudentIdentityPageList,
    operation?: string
  ): Promise<Response<StudentIdentityPageItemResponsePage>> {
    return commonRequestApi<StudentIdentityPageItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询学员身份有效期操作记录
   * @param page 分页信息
   * @param studentIdentityId 学员身份ID
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findValidPeriodRecordPageList(
    params: { page?: Page; studentIdentityId?: string },
    query: DocumentNode = GraphqlImporter.findValidPeriodRecordPageList,
    operation?: string
  ): Promise<Response<ValidPeriodRecordResponsePage>> {
    return commonRequestApi<ValidPeriodRecordResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取期数的每日一卷信息
   * @param schemeId
   * @param issueId
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getIssueDailyExamination(
    params: { schemeId?: string; issueId?: string },
    query: DocumentNode = GraphqlImporter.getIssueDailyExamination,
    operation?: string
  ): Promise<Response<DailyExaminationResponse>> {
    return commonRequestApi<DailyExaminationResponse>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 申请选课Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyChooseCourseToken(
    applyInfo: ApplyChooseCourseTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyChooseCourseToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请每日一卷Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyDailyExaminationToken(
    applyInfo: ApplyDailyExaminationTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyDailyExaminationToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请考试Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyExamLearningToken(
    applyInfo: ApplyExamLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyExamLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请考纲结构易错题Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyExamOutlineErrorPronePracticeLearningToken(
    applyInfo: ApplyExamOutlineErrorPronePracticeLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyExamOutlineErrorPronePracticeLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请考纲模式试题练习Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyExamOutlinePracticeLearningToken(
    applyInfo: ApplyExamOutlinePracticeLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyExamOutlinePracticeLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请试题方式易错题Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyQuestionTypeErrorPronePracticeLearningToken(
    applyInfo: ApplyQuestionTypeErrorPronePracticeLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyQuestionTypeErrorPronePracticeLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请随机抽题模式试题练习Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applyRandomPracticeLearningToken(
    applyInfo: ApplyRandomPracticeLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applyRandomPracticeLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 申请课程学习Token
   * @param applyInfo 申请信息
   * @param mutate 查询 graphql 语法文档
   * @param applyInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async applySingleCourseLearningToken(
    applyInfo: ApplySingleCourseLearningTokenRequest,
    mutate: DocumentNode = GraphqlImporter.applySingleCourseLearningToken,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { applyInfo },
      operation: operation
    })
  }

  /**   * 创建有效期类型期数
   * @param request
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createEffectiveLS(
    request: EffectiveLSCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createEffectiveLS,
    operation?: string
  ): Promise<Response<EffectiveLSAndCommoditySkuResponse>> {
    return commonRequestApi<EffectiveLSAndCommoditySkuResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 创建学员身份分组
   * @param createInfo 创建信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createGroup(
    createInfo: StudentIdentityGroupCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createGroup,
    operation?: string
  ): Promise<Response<StudentIdentityGroupResponse>> {
    return commonRequestApi<StudentIdentityGroupResponse>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 在指定的考前学习方案下新增期数
   * @param createInfo 期数创建信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createIssue(
    createInfo: PreExamLSIssueCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createIssue,
    operation?: string
  ): Promise<Response<IssueAndCommoditySkuResponse>> {
    return commonRequestApi<IssueAndCommoditySkuResponse>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 创建一个期数类型的学习方案
   * @param createInfo 创建信息
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createIssueLS(
    createInfo: PreExamLSCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createIssueLS,
    operation?: string
  ): Promise<Response<PreExamLSResponse>> {
    return commonRequestApi<PreExamLSResponse>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 缩减有效期
   * @param curtailInfo 缩减信息
   * @param mutate 查询 graphql 语法文档
   * @param curtailInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async curtailValidPeriod(
    curtailInfo: CurtailValidPeriodRequest,
    mutate: DocumentNode = GraphqlImporter.curtailValidPeriod,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { curtailInfo },
      operation: operation
    })
  }

  /**   * 延长有效期
   * @param extendInfo 延长信息
   * @param mutate 查询 graphql 语法文档
   * @param extendInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async extendValidPeriod(
    extendInfo: ExtendValidPeriodRequest,
    mutate: DocumentNode = GraphqlImporter.extendValidPeriod,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { extendInfo },
      operation: operation
    })
  }

  /**   * 发布有效期类型的学习方案
   * @param schemeId 学习方案ID
   * @param mutate 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async publishEffectiveLS(
    schemeId: string,
    mutate: DocumentNode = GraphqlImporter.publishEffectiveLS,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 发布学习方案
   * @param schemeId 学习方案ID
   * @param mutate 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async publishIssueLS(
    schemeId: string,
    mutate: DocumentNode = GraphqlImporter.publishIssueLS,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 删除有效期类型学习方案
   * @param schemeId 学习方案ID
   * @param mutate 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeEffectiveLS(
    schemeId: string,
    mutate: DocumentNode = GraphqlImporter.removeEffectiveLS,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 删除学员身份分组
   * @param id 分组ID
   * @param mutate 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeGroup(
    id: string,
    mutate: DocumentNode = GraphqlImporter.removeGroup,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { id },
      operation: operation
    })
  }

  /**   * 删除指定期数
   * @param schemeId 学习方案ID
   * @param issueId  期数ID
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeIssue(
    params: { schemeId?: string; issueId?: string },
    mutate: DocumentNode = GraphqlImporter.removeIssue,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 删除学习方案
   * @param schemeId 学习方案ID
   * @param mutate 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeIssueLS(
    schemeId: string,
    mutate: DocumentNode = GraphqlImporter.removeIssueLS,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 更新期数学习方案上下架状态
   * @param request
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCommoditySkuUppingStatus(
    request: CommoditySkuUppingRequest,
    mutate: DocumentNode = GraphqlImporter.updateCommoditySkuUppingStatus,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 更新有效期学习方案上下架状态
   * @param request
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateEffectiveCommoditySkuUppingStatus(
    request: EffectiveCommoditySkuUppingRequest,
    mutate: DocumentNode = GraphqlImporter.updateEffectiveCommoditySkuUppingStatus,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 更新有效期类型期数
   * @param request 期数更新信息
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateEffectiveLS(
    request: EffectiveLSUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateEffectiveLS,
    operation?: string
  ): Promise<Response<EffectiveLSAndCommoditySkuResponse>> {
    return commonRequestApi<EffectiveLSAndCommoditySkuResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 创建学员身份分组
   * @param updateInfo 更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateGroup(
    updateInfo: StudentIdentityGroupUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateGroup,
    operation?: string
  ): Promise<Response<StudentIdentityGroupResponse>> {
    return commonRequestApi<StudentIdentityGroupResponse>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 更新考前学习方案指定的期数
   * @param updateInfo 期数更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateIssue(
    updateInfo: PreExamLSIssueUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateIssue,
    operation?: string
  ): Promise<Response<IssueAndCommoditySkuResponse>> {
    return commonRequestApi<IssueAndCommoditySkuResponse>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 更新一个考前学习方案信息
   * @param updateInfo 更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateIssueLS(
    updateInfo: PreExamLSUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateIssueLS,
    operation?: string
  ): Promise<Response<PreExamLSResponse>> {
    return commonRequestApi<PreExamLSResponse>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 更新学员身份有效期
   * @param updateInfo 更新信息
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateStudentIdentity(
    updateInfo: StudentIdentityUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateStudentIdentity,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }
}

export default new DataGateway()
